module.exports = __webpack_public_path__ + "media/images/favicons/favicon-saturday-fd2d3c7e7dab86819914d5836bb1f81e.ico";